import { render, staticRenderFns } from "./UserUnifiedDashboard.vue?vue&type=template&id=476b90f6&scoped=true"
import script from "./UserUnifiedDashboard.vue?vue&type=script&lang=js"
export * from "./UserUnifiedDashboard.vue?vue&type=script&lang=js"
import style0 from "./UserUnifiedDashboard.vue?vue&type=style&index=0&id=476b90f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "476b90f6",
  null
  
)

export default component.exports